export const ParsePriceBand = value => parseFloat(parseFloat(value).toFixed(2));
